// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IrF6HPxRhoSplPJ23Snt {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  width: fit-content;
  border-radius: 9px;
  background-color: var(--campaign-join-in-fill-color);
  box-shadow: var(--campaign-join-in-glow);
  align-items: center;
  padding: 6px 10px 5px 6px;
  text-align: left;
  font-size: 13px;
  gap: 10px;
  color: white;
  cursor: pointer;
}
.IrF6HPxRhoSplPJ23Snt.h6aGIx3QNI30pP14J4ZT {
  padding: 6px 6px 5px 10px;
}
[data-side="distant"] .IrF6HPxRhoSplPJ23Snt {
  display: none;
}
.IrF6HPxRhoSplPJ23Snt[data-variant="card"][data-has-many="true"] {
  top: 15px;
  right: 15px;
  padding: 6px 10px 6px 6px;
}
.IrF6HPxRhoSplPJ23Snt[data-variant="card"][data-has-many="true"].h6aGIx3QNI30pP14J4ZT {
  padding: 6px 6px 6px 10px;
}
.h6aGIx3QNI30pP14J4ZT {
  flex-direction: row-reverse;
}
@keyframes eQX6oEREOrn2gHhE86sA {
  0% {
    transform: translateX(0) scale(1);
  }
  50% {
    transform: translateX(-10px) scale(1.05);
  }
  100% {
    transform: translateX(0) scale(1);
  }
}
.st3FCtvr328tew_APkNR {
  position: relative;
  display: block;
  flex-shrink: 0;
  min-width: 27px;
  height: 27px;
  width: 27px;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.ayTO3ZMkeflatSe1cQ2p .st3FCtvr328tew_APkNR {
  animation: kBT4nLkskYbY3b09O79g 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}
@keyframes kBT4nLkskYbY3b09O79g {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(10%);
  }
  100% {
    transform: translateX(0);
  }
}
.JGBPk43RiApD35d4eJTv {
  font-family: 'Futura PT';
  font-weight: 400;
  font-size: 19px;
  line-height: 100%;
  letter-spacing: 0.03em;
  vertical-align: middle;
  text-wrap: nowrap;
  transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.ayTO3ZMkeflatSe1cQ2p .JGBPk43RiApD35d4eJTv {
  animation: YxVvKZXyaFs2W3ncS_mA 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}
@keyframes YxVvKZXyaFs2W3ncS_mA {
  0% {
    opacity: 1;
  }
  30% {
    opacity: 0.4;
  }
  70% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
@media (max-width: 1024px) {
  .IrF6HPxRhoSplPJ23Snt {
    top: 8px;
    right: 8px;
    gap: 6px;
    border-radius: 6px;
    padding: 4px 6px 3px 4px;
  }
  .IrF6HPxRhoSplPJ23Snt.h6aGIx3QNI30pP14J4ZT {
    padding: 4px 4px 3px 6px;
  }
  .IrF6HPxRhoSplPJ23Snt[data-variant="card"][data-has-many="true"] {
    top: 10px;
    right: 10px;
    padding: 4px 6px 4px 4px;
  }
  .IrF6HPxRhoSplPJ23Snt[data-variant="card"][data-has-many="true"].h6aGIx3QNI30pP14J4ZT {
    padding: 4px 4px 4px 6px;
  }
  .IrF6HPxRhoSplPJ23Snt[data-variant="card"][data-has-many="false"] {
    top: 7px;
    right: 7px;
  }
  .st3FCtvr328tew_APkNR {
    min-width: 18px;
    width: 18px;
    height: 19px;
  }
  .JGBPk43RiApD35d4eJTv {
    font-size: 13px;
    letter-spacing: 0.042em;
    text-transform: capitalize;
  }
}
@media (orientation: portrait) {
  .IrF6HPxRhoSplPJ23Snt {
    border-radius: 6px;
  }
  .IrF6HPxRhoSplPJ23Snt[data-variant="panel"] {
    top: 8px;
    right: 8px;
    gap: 6px;
    padding: 4px 6px 3px 4px;
  }
  .IrF6HPxRhoSplPJ23Snt[data-variant="panel"].h6aGIx3QNI30pP14J4ZT {
    padding: 4px 4px 3px 6px;
  }
  .IrF6HPxRhoSplPJ23Snt[data-variant="panel"] .st3FCtvr328tew_APkNR {
    min-width: 18px;
    width: 18px;
    height: 19px;
  }
  .IrF6HPxRhoSplPJ23Snt[data-variant="panel"] .JGBPk43RiApD35d4eJTv {
    font-size: 13px;
    letter-spacing: 0.042em;
    text-transform: capitalize;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .IrF6HPxRhoSplPJ23Snt[data-view="multi"][data-variant="card"] {
    top: 9px;
    right: 8px;
    padding: 5px 6px 4px 5px;
  }
  .IrF6HPxRhoSplPJ23Snt[data-view="multi"][data-variant="card"].h6aGIx3QNI30pP14J4ZT {
    padding: 5px 5px 4px 6px;
  }
  .IrF6HPxRhoSplPJ23Snt[data-view="multi"][data-variant="card"] .st3FCtvr328tew_APkNR {
    min-width: 14px;
    width: 14px;
    height: 14px;
  }
  .IrF6HPxRhoSplPJ23Snt[data-view="multi"][data-variant="card"] .JGBPk43RiApD35d4eJTv {
    font-size: 12px;
    letter-spacing: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/JoinIn/JoinInButton.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,oDAAoD;EACpD,wCAAwC;EACxC,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,iCAAiC;EACnC;AACF;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,iDAAiD;AACnD;AACA;EACE,+EAAsE;AACxE;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,qDAAqD;AACvD;AACA;EACE,0EAA8D;AAChE;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,QAAQ;IACR,UAAU;IACV,QAAQ;IACR,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,SAAS;IACT,WAAW;IACX,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,uBAAuB;IACvB,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;IACR,UAAU;IACV,QAAQ;IACR,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,uBAAuB;IACvB,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,QAAQ;IACR,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".joinBtn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  display: flex;\n  width: fit-content;\n  border-radius: 9px;\n  background-color: var(--campaign-join-in-fill-color);\n  box-shadow: var(--campaign-join-in-glow);\n  align-items: center;\n  padding: 6px 10px 5px 6px;\n  text-align: left;\n  font-size: 13px;\n  gap: 10px;\n  color: white;\n  cursor: pointer;\n}\n.joinBtn.joined {\n  padding: 6px 6px 5px 10px;\n}\n[data-side=\"distant\"] .joinBtn {\n  display: none;\n}\n.joinBtn[data-variant=\"card\"][data-has-many=\"true\"] {\n  top: 15px;\n  right: 15px;\n  padding: 6px 10px 6px 6px;\n}\n.joinBtn[data-variant=\"card\"][data-has-many=\"true\"].joined {\n  padding: 6px 6px 6px 10px;\n}\n.joined {\n  flex-direction: row-reverse;\n}\n@keyframes slideSuccess {\n  0% {\n    transform: translateX(0) scale(1);\n  }\n  50% {\n    transform: translateX(-10px) scale(1.05);\n  }\n  100% {\n    transform: translateX(0) scale(1);\n  }\n}\n.joinBtnIcon {\n  position: relative;\n  display: block;\n  flex-shrink: 0;\n  min-width: 27px;\n  height: 27px;\n  width: 27px;\n  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.animate .joinBtnIcon {\n  animation: moveToRight 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\n}\n@keyframes moveToRight {\n  0% {\n    transform: translateX(-100%);\n  }\n  50% {\n    transform: translateX(10%);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n.joinBtnText {\n  font-family: 'Futura PT';\n  font-weight: 400;\n  font-size: 19px;\n  line-height: 100%;\n  letter-spacing: 0.03em;\n  vertical-align: middle;\n  text-wrap: nowrap;\n  transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.animate .joinBtnText {\n  animation: fadeText 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n@keyframes fadeText {\n  0% {\n    opacity: 1;\n  }\n  30% {\n    opacity: 0.4;\n  }\n  70% {\n    opacity: 0.6;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@media (max-width: 1024px) {\n  .joinBtn {\n    top: 8px;\n    right: 8px;\n    gap: 6px;\n    border-radius: 6px;\n    padding: 4px 6px 3px 4px;\n  }\n  .joinBtn.joined {\n    padding: 4px 4px 3px 6px;\n  }\n  .joinBtn[data-variant=\"card\"][data-has-many=\"true\"] {\n    top: 10px;\n    right: 10px;\n    padding: 4px 6px 4px 4px;\n  }\n  .joinBtn[data-variant=\"card\"][data-has-many=\"true\"].joined {\n    padding: 4px 4px 4px 6px;\n  }\n  .joinBtn[data-variant=\"card\"][data-has-many=\"false\"] {\n    top: 7px;\n    right: 7px;\n  }\n  .joinBtnIcon {\n    min-width: 18px;\n    width: 18px;\n    height: 19px;\n  }\n  .joinBtnText {\n    font-size: 13px;\n    letter-spacing: 0.042em;\n    text-transform: capitalize;\n  }\n}\n@media (orientation: portrait) {\n  .joinBtn {\n    border-radius: 6px;\n  }\n  .joinBtn[data-variant=\"panel\"] {\n    top: 8px;\n    right: 8px;\n    gap: 6px;\n    padding: 4px 6px 3px 4px;\n  }\n  .joinBtn[data-variant=\"panel\"].joined {\n    padding: 4px 4px 3px 6px;\n  }\n  .joinBtn[data-variant=\"panel\"] .joinBtnIcon {\n    min-width: 18px;\n    width: 18px;\n    height: 19px;\n  }\n  .joinBtn[data-variant=\"panel\"] .joinBtnText {\n    font-size: 13px;\n    letter-spacing: 0.042em;\n    text-transform: capitalize;\n  }\n}\n@media (--campaign-mobile) {\n  .joinBtn[data-view=\"multi\"][data-variant=\"card\"] {\n    top: 9px;\n    right: 8px;\n    padding: 5px 6px 4px 5px;\n  }\n  .joinBtn[data-view=\"multi\"][data-variant=\"card\"].joined {\n    padding: 5px 5px 4px 6px;\n  }\n  .joinBtn[data-view=\"multi\"][data-variant=\"card\"] .joinBtnIcon {\n    min-width: 14px;\n    width: 14px;\n    height: 14px;\n  }\n  .joinBtn[data-view=\"multi\"][data-variant=\"card\"] .joinBtnText {\n    font-size: 12px;\n    letter-spacing: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"joinBtn": `IrF6HPxRhoSplPJ23Snt`,
	"joined": `h6aGIx3QNI30pP14J4ZT`,
	"joinBtnIcon": `st3FCtvr328tew_APkNR`,
	"animate": `ayTO3ZMkeflatSe1cQ2p`,
	"moveToRight": `kBT4nLkskYbY3b09O79g`,
	"joinBtnText": `JGBPk43RiApD35d4eJTv`,
	"fadeText": `YxVvKZXyaFs2W3ncS_mA`,
	"slideSuccess": `eQX6oEREOrn2gHhE86sA`
};
export default ___CSS_LOADER_EXPORT___;
